import type { RouteLocationRaw, RouteRecordRaw } from 'vue-router'

export const OLD_B_URL = `${import.meta.env.VITE_B_URL}/user.html?from=B#`

export function findFirstRouteWithPermission(routes: RouteRecordRaw[]): RouteLocationRaw {
  const permissions = JSON.parse(sessionStorage.getItem('permissions') || '[]')
  // 遍历子路由，找到第一个有权限的页面
  for (const child of routes) {
    // 如果有权限要求且有权限，返回该路由
    if (child.meta?.permission) {
      const hasPermission = (child.meta.permission as string[])?.some((permission: string) =>
        permissions.includes(permission),
      )
      if (hasPermission)
        return { name: child.name }
    }

    // 如果有子路由，递归查找
    if (child.children?.length) {
      const firstChildRoute = findFirstRouteWithPermission(child.children)
      if (typeof firstChildRoute === 'object' && 'name' in firstChildRoute && firstChildRoute.name !== 'NoPermission')
        return firstChildRoute
    }

    // 如果没有权限要求且没有子路由，返回该路由
    if (!child.meta?.permission && !child.children?.length)
      return { name: child.name }
  }

  return { path: '/no-permission' }
}
